// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__WD9xa","buttonLarge":"Button_buttonLarge__a_Vsw","icon":"Button_icon__bamhK"};